import { useState } from "react";
import { Link as ScrollLink, scroller } from "react-scroll";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Función para manejar el click en "Inicio"
  const handleInicioClick = () => {
    if (window.location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.location.href = "/"; // Redirigir al inicio
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 500);
    }
    setIsOpen(false);
  };

  // Función para manejar el click en una sección desde cualquier parte del sitio
  const handleSectionClick = (section) => {
    if (window.location.pathname === "/") {
      scroller.scrollTo(section, { smooth: true, duration: 500, offset: -70 });
    } else {
      window.location.href = "/"; // Redirigir al inicio
      setTimeout(() => {
        scroller.scrollTo(section, { smooth: true, duration: 500, offset: -70 });
      }, 500);
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-gray-900 text-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center h-16">
        {/* LOGO */}
        <button onClick={handleInicioClick} className="flex items-center">
          <img
            src="/images/logo.jpeg"
            alt="Logo"
            className="h-14 w-auto cursor-pointer"
          />
        </button>

        {/* Botón menú en móvil */}
        <button className="md:hidden text-2xl" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX /> : <FiMenu />}
        </button>

        {/* Menú */}
        <ul
          className={`md:flex gap-6 absolute md:static top-16 left-0 w-full bg-gray-900 md:w-auto md:bg-transparent transition-transform ${
            isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
          }`}
        >
          {/* Secciones del inicio */}
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("seccion1")} className="hover:text-gray-400">
              Inicio
            </button>
          </li>
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("seccion2")} className="hover:text-gray-400">
              Pericias en Incendios
            </button>
          </li>
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("seccion3")} className="hover:text-gray-400">
              Sobre mí
            </button>
          </li>
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("seccion4")} className="hover:text-gray-400">
              Casos Resueltos
            </button>
          </li>
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("seccion5")} className="hover:text-gray-400">
              Capacitaciones
            </button>
          </li>
          <li className="p-4 md:p-0">
            <button onClick={() => handleSectionClick("contacto")} className="hover:text-gray-400">
              Contacto
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
